module.exports = __webpack_public_path__ + "static/media/euro-sign.ac417f15.svg";